import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, ifEmptyReturn, isEmptyArray, isEmptyVariable, sortTable, truncateString} from '../../common/Global/commonFunctions';
import {Modal, Pagination} from 'react-bootstrap';
import { AddNewButtonLayout, SearchSpan } from '../../common/Global/globalStyles.style';
import AlertDialog from '../../common/AlertDialog';
import AddFrameworkAccessDialog from './addFrameworkAccessDialog';
import FilterDropDown from '../../common/DropdownMenus/FilterDropdown';
import TableDropDown from '../../common/DropdownMenus/TableDropdown';

let userDetails = getLocalStorageVariables();

const sortClientName = "companyName";

class FrameworkAccessDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientList:[],
            frameworkAccessList:[],
            showAddAccessDialog:false,
            showAlertDialog:false,
            alertDialogHeading:"",
            alertDialogMessage:"",
            showBtnLoader:false,
            componentDidMountFlag:false,
            apiSearchKey:"",
            searchKey:"",
            currentPageNo: 1,
            resultSize:Constants.RESULT_SIZE,
            resultSizePlaceholder:Constants.RESULT_SIZE,
            sort:sortClientName,
            sortDir:"asc",
            status:"Active",
            searchkey: "",
            resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
            frameworks: [],
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showClientAccessDialog){
            this.setState({
                clientList:[],
                frameworkAccessList:[],
                showAddAccessDialog:false,
                showAlertDialog:false,
                alertDialogHeading:"",
                alertDialogMessage:"",
                showBtnLoader:false,
                componentDidMountFlag:false,
                apiSearchKey:"",
                searchKey:"",
                currentPageNo: 1,
                resultSize:Constants.RESULT_SIZE,
                resultSizePlaceholder:Constants.RESULT_SIZE,
                sort:sortClientName,
                sortDir:"asc",
                status:"Active",
                searchkey: "",
                resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
                frameworks: [],
            }, () => {
                this.getFrameworkAccess();
            })
        }
    }

    // Handle result size dropdown click
    resultSizeDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.resultSizeArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label ;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            resultSizeArr:tempArr,
            resultSize:item.label,
            resultSizePlaceholder:placeholder
        },() => {
            this.getFrameworkAccess();
        })
    }

    // Updates state with input field changes.
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    // Handle search icon click
    onSearchIconClick = () => {
        this.getFrameworkAccess();
    }

    // Handles the enter key press event to create a master.
    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.getFrameworkAccess();
        }
    }

    // Handle sort table data
    sortTableLocal = (sortColumn) => {
        let sortObj = sortTable(sortColumn,this.state.sort,this.state.sortDir);
    
        this.setState({
            sort:sortObj.sortTemp,
            sortDir:sortObj.sortDirTemp,
        },()=>{
            this.getFrameworkAccess();
        })
    }

    // Method to handle alert dialog close
    handleAlertDialogClose = () => {
        this.setState({
            showAlertDialog:false
        })
    }

    // Handle to show add client Access modal
    handleGiveAccess = () => {
        this.setState({
            showAddAccessDialog:true
        })
    }

    // Handle to add access dialog close event
    handleAddAccessDialogClose = (reloadFlag) => {
        this.setState({
            showAddAccessDialog:false
        }, () => {
            if(reloadFlag == true){
                this.getFrameworkAccess();
            }
        })
    }

    // Handle table action menu items click events
    onTableDropDownItemClick = (item, dropdownItem) => {
        if(item.label === "Delete"){
            this.setState({
                operationType:item.label,
                clientId:dropdownItem.clientId,
                showAlertDialog:true,
                alertDialogHeading:"Delete client access",
                proceedBtnLabel:"Delete",
                alertDialogMessage:"Are you sure you want to delete client access "+
                dropdownItem.companyName+", "+dropdownItem.city+"?"
            })
        }
    }

    /*******************API CALLS*******************/
    getFrameworkAccess = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.GetFrameworkAccess,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                pageNo:this.state.currentPageNo,
                search:this.state.searchKey,
                resultsize:this.state.resultSize,
                status:this.state.status,
                sort:this.state.sort,
                sortDir:this.state.sortDir
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    componentDidMountFlag:true,
                    frameworkAccessList:data.data.result,
                    clientList:data.data.clients,
                    frameworks:data.data.frameworks,
                    totalClientCount:data.data.count,
                    apiSearchKey:this.state.searchKey,
                })
            }else{
                this.setState({
                    frameworkAccessList:[],
                    totalClientCount:0,
                    showLoader:false,
                    componentDidMountFlag:true,
                    apiSearchKey:this.state.searchKey,
                })
            }
        });
    }

    onChangePage = (page) => {
        // update state with new page of items

        if(page !== this.state.currentPageNo){
            this.setState({
                showLoader:true,
            });
            
            fetch(Constants.GetFrameworkAccess,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:page,
                    search:this.state.searchKey,
                    resultsize:this.state.resultSize,
                    status:this.state.status,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        showLoader:false,
                        componentDidMountFlag:true,
                        frameworkAccessList:data.data.result,
                        totalClientCount:data.data.count,
                        apiSearchKey:this.state.searchKey,
                        currentPageNo:page,
                    })
                }else{
                    this.setState({
                        frameworkAccessList:[],
                        showLoader:false,
                        componentDidMountFlag:true,
                        apiSearchKey:this.state.searchKey,
                    })
                }
            });
        }
    }

    deleteFrameworkAccess = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.DeleteFrameworkAccess,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                clientId:this.state.clientId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    clientId:"",
                    alertDialogHeading:"",
                    proceedBtnLabel:"",
                    alertDialogMessage:"",
                    showAlertDialog:false,
                    actionType:"",
                },() => {
                    this.getFrameworkAccess();
                });
            }else{
                this.setState({
                    showLoader:false,
                    clientId:"",
                    alertDialogHeading:"",
                    proceedBtnLabel:"",
                    alertDialogMessage:"",
                    actionType:"",
                    showAlertDialog:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }
    /*******************API CALLS END HERE*******************/

    render() {
        const actionArr = [
            {
                icon:"delete",
                label:"Delete"
            }
        ]
        return(
            <>
                <Modal className="show-framework-tree-dialog custom-dialog" show={this.props.showClientAccessDialog} onHide={this.props.handleAccessDialogClose} backdrop="static">
                    <Modal.Header>
                        <h5>{"Framework Access"}</h5>
                        <button 
                            onClick={this.props.handleAccessDialogClose}
                            type="button" data-dismiss="modal">
                            <span className="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="search-addnew-bg">
                            <div className="search-addnew">
                                <div className="search-filter-layout">
                                    <FilterDropDown
                                        placeholder={this.state.resultSizePlaceholder}
                                        dropdownArr={this.state.resultSizeArr}
                                        onDropDownItemClick={this.resultSizeDropdownClick}
                                        themeSettings={this.props.themeSettings}
                                        mleft={0}
                                    />
                                    <div className="search-col m-l-10">
                                        <input 
                                            name="searchKey" 
                                            type="text"
                                            onChange={this.handleChange}
                                            placeholder="Search" 
                                            onKeyPress={this.onEnterBtnPress}
                                            value={this.state.searchKey} />
                                        <SearchSpan
                                            className="material-icons"
                                            themeSettings={this.props.themeSettings}
                                            onClick = {this.onSearchIconClick}>search</SearchSpan>
                                    </div>
                                </div>
                                <div className="flex-center-layout">
                                    <AddNewButtonLayout themeSettings={this.props.themeSettings}>
                                        <a onClick={this.handleGiveAccess} href="javascript:void(0);"
                                            style={{ pointerEvents: this.state.isButtonDisabled ? 'none' : 'auto', opacity: this.state.isButtonDisabled ? 0.5 : 1 }}>
                                            <span className="material-icons">add_circle</span>
                                            <p>Give Access</p>
                                        </a>
                                    </AddNewButtonLayout>
                                </div>
                            </div>
                        </div>
                        {
                            !isEmptyArray(this.state.frameworkAccessList) && 
                            <div className="common-tab-bg">
                                <div className="common-table" style={{width:"100%"}}>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="text-center" width={"5%"}>No</th>
                                                <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortClientName)} width={"35%"}>
                                                    <div className="sort-header">Client Name
                                                        <span className={(this.state.sort === sortClientName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                    </div>
                                                </th>
                                                <th className="c-pointer">Framework</th>
                                                <th className="text-center" width={"5%"}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                !isEmptyArray(this.state.frameworkAccessList) && 
                                                this.state.frameworkAccessList.map((item,idx) => {
                                                    let framework = isEmptyVariable(item.frameworkIds)?"-":JSON.parse(item.frameworkIds)
                                                        .map(id => this.state.frameworks.find(e => e.frameworkId === id))
                                                        .map(framework => `${framework.frameworkName}`)
                                                        .join(', ');
                                                    return <tr>
                                                        <td className="text-center">{((this.state.currentPageNo - 1) * this.state.resultSize) + (++idx)}</td>
                                                        <td>{item.companyName+ ", "+ item.city}</td>
                                                        <td>{truncateString(String(framework).split("(")[0],Constants.STRING_LENGTH)}</td>
                                                        <td className="text-center">
                                                            <TableDropDown
                                                                actionArr={actionArr}
                                                                onDropDownItemClick={this.onTableDropDownItemClick}
                                                                dropDownId={item}
                                                                themeSettings={this.props.themeSettings}
                                                            />
                                                        </td>
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                        {
                            this.state.componentDidMountFlag && isEmptyArray(this.state.frameworkAccessList) &&
                            <div class="no-items-layout">
                                <div class="no-items-card">
                                    <h6>
                                    {
                                        isEmptyVariable(this.state.apiSearchKey)?
                                        Constants.NO_RECORDS_WARNING
                                        :
                                        Constants.EMPTY_SEARCH_WARNING
                                    }
                                    </h6>
                                </div>
                            </div>
                        }
                        <div className="pagination-layout">
                            <div className="row custom-row">
                                <div className="col-md-9 custom-col">
                                {
                                    (this.state.totalClientCount > this.state.frameworkAccessList.length) && 
                                    <Pagination
                                        totalLength ={this.state.totalClientCount} 
                                        items={this.state.frameworkAccessList} 
                                        onChangePage={this.onChangePage} 
                                        pageSize={this.state.resultSize}
                                        currentPageNo = {this.state.currentPageNo}
                                        initialPage={this.state.currentPageNo} 
                                        themeSettings={this.props.themeSettings}/>
                                }
                                </div>
                                <div className="col-md-3 custom-col">
                                    <p>{"Total Records: "+this.state.totalClientCount}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <AlertDialog
                    showAlertDialog={this.state.showAlertDialog}
                    handleAlertDialogClose={this.handleAlertDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={this.state.alertDialogHeading}
                    alertDialogMessage={this.state.alertDialogMessage}
                    proceedBtnClick={this.deleteFrameworkAccess}
                    proceedBtnLabel={this.state.proceedBtnLabel}
                    showLoader={this.state.showBtnLoader}
                    themeSettings={this.props.themeSettings}
                />

                <AddFrameworkAccessDialog
                    showAddAccessDialog={this.state.showAddAccessDialog}
                    handleAddAccessDialogClose={this.handleAddAccessDialogClose}
                    themeSettings={this.props.themeSettings}
                    frameworks={this.state.frameworks}
                    frameworkAccessList={this.state.frameworkAccessList}
                    clientList={this.state.clientList}
                />
            </>
        )
    }

}
export default FrameworkAccessDialog;